// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import type { Location, Match, RouterHistory } from 'react-router-dom'
import { Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import CustomerTargetPage from './CustomerTargetPage'
import css from './customerTargetRoot.css'
type Props = {
  history: RouterHistory
  location: Location
  match: Match
}
type State = {
  isSavingCustomerTarget: boolean
  saveCustomerTargetErrorMessage: string | undefined
}

class CustomerTargetRoot extends React.PureComponent<Props, State> {
  state: State = {
    isSavingCustomerTarget: false,
    saveCustomerTargetErrorMessage: undefined,
  }

  setIsSavingCustomerTarget = (value: boolean) => {
    this.setState({ isSavingCustomerTarget: value })
  }

  setSaveCustomerTargetErrorMessage = (value: string | undefined) => {
    this.setState({ saveCustomerTargetErrorMessage: value })
  }

  render() {
    const { match } = this.props
    const { isSavingCustomerTarget, saveCustomerTargetErrorMessage } = this.state
    return (
      <div className={css.component}>
        <Header title={i18n.t('customerTarget.header')} />
        <Container>
          <Typography variant='h6'>{i18n.t('customerTarget.header')}</Typography>
          <Switch>
            <Route
              path={`${match.path}/:week`}
              render={(props) => (
                <CustomerTargetPage
                  {...props}
                  isSavingCustomerTarget={isSavingCustomerTarget}
                  setIsSavingCustomerTarget={this.setIsSavingCustomerTarget}
                  saveCustomerTargetErrorMessage={saveCustomerTargetErrorMessage}
                  setSaveCustomerTargetErrorMessage={this.setSaveCustomerTargetErrorMessage}
                />
              )}
            />
            <Route
              exact
              path={`${match.path}`}
              render={(props) => (
                <CustomerTargetPage
                  {...props}
                  isSavingCustomerTarget={isSavingCustomerTarget}
                  setIsSavingCustomerTarget={this.setIsSavingCustomerTarget}
                  saveCustomerTargetErrorMessage={saveCustomerTargetErrorMessage}
                  setSaveCustomerTargetErrorMessage={this.setSaveCustomerTargetErrorMessage}
                />
              )}
            />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(CustomerTargetRoot)
